import { Switch as MantineSwitch } from '@mantine/core';

import classes from './Switch.module.css';

const SwitchDefaults = MantineSwitch.extend({
  defaultProps: {
    size: 'lg',
  },
  classNames: {
    root: classes.root,
    input: classes.input,
    track: classes.track,
    thumb: classes.thumb,
  },
});

const Switch = MantineSwitch;

export { Switch, SwitchDefaults };
